export default __webpack_public_path__ + "static/media/pic3.b7b7e6ef.jpg";